import { render, staticRenderFns } from "./folder-item.vue?vue&type=template&id=421b7dba&scoped=true&"
import script from "./folder-item.vue?vue&type=script&lang=js&"
export * from "./folder-item.vue?vue&type=script&lang=js&"
import style0 from "./folder-item.vue?vue&type=style&index=0&id=421b7dba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b7dba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421b7dba')) {
      api.createRecord('421b7dba', component.options)
    } else {
      api.reload('421b7dba', component.options)
    }
    module.hot.accept("./folder-item.vue?vue&type=template&id=421b7dba&scoped=true&", function () {
      api.rerender('421b7dba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/folder-item/folder-item.vue"
export default component.exports